import { createSlice } from "@reduxjs/toolkit";

const storageSlice = createSlice({
  name: "storage",
  initialState: {},
  reducers: {
    updateImage: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateImage } = storageSlice.actions;
export default storageSlice.reducer;
